<script>
import CommonConstants from '../../common/Constants';

import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toolbar from 'primevue/toolbar';
import Dialog from 'primevue/dialog';
import GenericCustomMasterDataSelect from '@/components/generic/GenericCustomMasterDataSelect.vue'
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue'
import GenericBooleanDropdown from '@/components/generic/GenericBooleanDropdown.vue'
import LabelField from '@/components/generic/LabelField.vue';

import Service from '@/services/movement-instruction';
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { readonly } from 'vue';

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Dialog, Toolbar, Card, DataTable, Column,
    GenericCustomMasterDataAutocompleteV2, GenericBooleanDropdown, GenericCustomMasterDataSelect, 
    ResponsiveButton, 
    InputText, Textarea, LabelField
  },
  props: ['id', 'readOnly', 'proposal', 'lotCode'],
  data(){
    return {
      submitted: false,
      selectedItems: [],
      items: [],
      receiversItems: [],

      selectedDocument: null,
      documentItemDisabled: false,
      submittedItem: false,
      documentDialogVisible: false,
      documentItem: {
        idRegistryDocumentType: null,
        isCounterSignedByInspector: false,
        isCounterSignedByThirdparty: false,
        isIssuedByThirdparty: false,
        note: null
      },
      
      documentReceiverDialogVisible: false,
      documentReceiverDisabled: false,
      submittedReceiver: false,
      documentReceiverItem: {
        idRegistryDocumentReceiver: null,
        numberOfOriginals: 0,
        numberOfCopies: 0
      },
      dischargeTrackingRecordId: null,
      expandedRows: []
    }
  },
  validations(){
    return {
      documentItem: {
        idRegistryDocumentType: {required},
        isCounterSignedByInspector: {required},
        isCounterSignedByThirdparty: {required},
        isIssuedByThirdparty: {required},
        note: {}
      },
      documentReceiverItem: {
        idRegistryDocumentReceiver: {required},
        numberOfOriginals: {required},
        numberOfCopies: {required}
      }
    }
  },
  mounted(){
    if(this.id){
      this.loadData();
      this.loadDischargeTrackingRecord();
    }
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      },
      lotProposal(){
        if(this.proposal && this.proposal.parcels && this.proposal.parcels.length > 0){
          let p = this.proposal.parcels.find(x => x.movementInstructionLotCode == this.lotCode);
          return p;
        }
        return {};
      }
  },
  methods: {
    reload(){
      this.loadData();
    },
    loadDischargeTrackingRecord(){
      Service.getVesselProtocolDischargeTrackingByLotId(this.id, response => {
        if(response.success){
          this.dischargeTrackingRecordId = response.data.id
        }
      })
    },
    loadData(){
      let filters = [
        {
          operator: 'eq',
          value: this.id,
          property: 'IdMovementInstructionLot'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      Service.getDocuments(params, response => {
        if(response.success){
          this.items = response.data;
        }
      });
    },

    submitSaveDocument(){
      this.submittedItem = true;
      if(!this.v$.documentItem.$invalid){
        this.documentItemDisabled = true;
        if(this.documentItem.id){

          Service.updateDocument(this.documentItem, 
            response => {
              this.submittedItem = false;
              this.documentItemDisabled = false;
              if(response.success){
                this.loadData();
                this.documentDialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          
          Service.createDocument(this.documentItem, 
            response => {
              this.submittedItem = false;
              this.documentItemDisabled = false;
              if(response.success){
                this.loadData();
                this.documentDialogVisible = false;
                this.submitted = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )

        }
      }
    },
    submitSaveDocumentReceiver(){
      this.submittedReceiver = true;
      if(!this.v$.documentReceiverItem.$invalid){
        this.documentReceiverDisabled = true;
        if(this.documentReceiverItem.id){
          Service.updateDocumentReceiver(this.documentReceiverItem, 
            response => {
              this.submittedReceiver = false;
              this.documentReceiverDisabled = false;
              if(response.success){
                this.loadReceivers(this.documentReceiverItem.idMovementInstructionLotDocument);
                this.documentReceiverDialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          Service.createDocumentReceiver(this.documentReceiverItem, 
            response => {
              this.submittedReceiver = false;
              this.documentReceiverDisabled = false;
              if(response.success){
                let idMovementInstructionLotDocument = this.documentReceiverItem.idMovementInstructionLotDocument;
                this.loadReceivers(idMovementInstructionLotDocument);
                this.documentReceiverDialogVisible = false;
                this.submitted = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }
      }
    },

    onDeleteDocument(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.deleteDocument(data.id, 
            response => {
              if(response.success){
                this.loadData();
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
    },
    onItemSelect(e){
      this.selectedDocument = e.data.id;
      this.loadReceivers(e.data.id);
    },
    loadReceivers(documentId){
      let filters = [
        {
          operator: 'eq',
          value: documentId,
          property: 'IdMovementInstructionLotDocument'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      Service.getDocumentReceivers(params, response => {
        if(response.success){
          this.receiversItems = response.data;
        }else{
          this.receiversItems = [];
        }
      })
    },
    onDeleteDocumentReceiver(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.deleteDocumentReceiver(data.id, 
            response => {
              if(response.success){
                this.loadReceivers(data.idMovementInstructionLotDocument);
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
    },
    openDocumentDialog(){
      this.documentItem = {
        idMovementInstructionLot: this.id,
        idRegistryDocumentType: null,
        isCounterSignedByInspector: false,
        isCounterSignedByThirdparty: false,
        isIssuedByThirdparty: false,
        note: null
      };
      this.documentDialogVisible = true;
    },
    openDocumentDialogEdit(data){
      this.documentItem = {...data};
      this.documentDialogVisible = true;
    },
    openDocumentReceiverDialog(){
      if(this.selectedDocument){
      this.documentReceiverItem = {
        idMovementInstructionLotDocument: this.selectedDocument,
        idRegistryDocumentReceiver: null,
        numberOfOriginals: 0,
        numberOfCopies: 0
      }
      this.documentReceiverDialogVisible = true;
      }else{
        this.$toast.add({detail: this.$t('movementInstructions.messages.bolHeaderNotSelected'), life:3000, severity:'error'});
      }
    },
    openDocumentReceiverDialogEdit(data){
      this.documentReceiverItem = {...data};
      this.documentReceiverDialogVisible = true;
    },
    openProposal(e){
      if(this.proposal && this.proposal.parcels && this.proposal.parcels.length > 0){
          let p = this.proposal.parcels.find(x => x.movementInstructionLotCode == this.lotCode);
          for(let i=0; i<p.documents.length; i++){
            let d = p.documents[i];
            let o = 0;
            try{
              o = parseInt(d.originals);
            }catch{
              o = 0;
            }
            let c = 0;
            try{
              c = parseInt(d.copies);
            }catch{
              o = 0;
            }
            d.toSend = {
              idRegistryDocument: d.idRegistryDocument,
              isCounterSignedByInspector: d.counterSignedBySurveyor,
              isCounterSignedByThirdparty: d.counterSignedOrIssueByOther,
              isIssuedByThirdparty: d.counterSignedBySurveyor,
              notes: d.notes,
              receivers: [
                { idRegistryDocumentReceiver: 12, registryDocumentReceiver: "GESTIONE OPERATIVA SUO USO", originals: 0, copies: 1 },
                { idRegistryDocumentReceiver: 9, registryDocumentReceiver: "CLIENTE", originals: o, copies: c ? (c-2) : 0 },
                { idRegistryDocumentReceiver: 14, registryDocumentReceiver: "A BORDO SUO USO", originals: 0, copies: 1 },
                { idRegistryDocumentReceiver: 15, registryDocumentReceiver: "A BORDO PER RICEVITORI", originals: 0, copies: 1 }
              ]
            }


          }
      }
      this.$refs.proposalop.toggle(e);
    },
    checkDocument(item){
      let found = this.items.find(i => i.idRegistryDocumentType == item.toSend.idRegistryDocument);
      return found;
    },
    applySaveDocument(item){
      if(this.checkDocument(item)){
        this.$confirm.require({
        message: this.$t('messages.item_exists_replace_message'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          this.performSaveDocumentProposal(item)
          this.$confirm.close();
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
      }else{
        this.performSaveDocumentProposal(item);
      }
    },
    applySaveDocumentAll(){
      let body = [];

      for(let k=0; k<this.lotProposal.documents.length; k++){

        let item = this.lotProposal.documents[k];
        if(item.toSend.idRegistryDocument){
        let d = {
          document: {
            idMovementInstructionLot: this.id,
            idRegistryDocumentType: item.toSend.idRegistryDocument,
            isCounterSignedByInspector: item.counterSignedBySurveyor,
            isCounterSignedByThirdparty: item.counterSignedOrIssueByOther,
            isIssuedByThirdparty: item.counterSignedBySurveyor,
            note: item.toSend.notes
          },
          receiversList: []
        }

        for(let i=0; i< item.toSend.receivers.length; i++){
          let r = {
            documentReceiverDescription: item.toSend.receivers[i].registryDocumentReceiver,
            numberOfOriginals: item.toSend.receivers[i].originals ?? 0,
            numberOfCopies: item.toSend.receivers[i].copies ?? 0
          };
          d.receiversList.push(r)
        }
        

        body.push(d)
      }
      }

      Service.saveLotDocumentWithReceivers(body, response => {
        if(response.success){
          this.loadData();
          this.$refs.proposalop.toggle();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
        }else{
            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
      })
    },
    performSaveDocumentProposal(item){
      let body = {
        document: {
          idMovementInstructionLot: this.id,
          idRegistryDocumentType: item.toSend.idRegistryDocument,
          isCounterSignedByInspector: item.counterSignedBySurveyor,
          isCounterSignedByThirdparty: item.counterSignedOrIssueByOther,
          isIssuedByThirdparty: item.counterSignedBySurveyor,
          note: item.toSend.notes
        },
        receiversList: []
      };

      for(let i=0; i< item.toSend.receivers.length; i++){
        body.receiversList.push({
          documentReceiverDescription: item.toSend.receivers[i].registryDocumentReceiver,
          numberOfOriginals: item.toSend.receivers[i].originals ?? 0,
          numberOfCopies: item.toSend.receivers[i].copies ?? 0
        })
      }
      
      let a = [];
      a.push(body)

      Service.saveLotDocumentWithReceivers(a, response => {
        if(response.success){
          this.loadData();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
        }else{
            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
      })
    }
  }
}
</script>


<style scoped>
.custom-card-title{
  font-size: 18px;
}
</style>

<template>
  <main>
    <OverlayPanel ref="proposalop">
      <DataTable :reorderableColumns="true" :value="lotProposal.documents" showGridlines stripedRows dataKey="idRegistryDocument" v-model:expandedRows="expandedRows">
        <template #header>
            <div>
              <LabelField :label="$t('VesselNomination.parcel.masterForHisOwnUse')" :value="lotProposal.masterForHisOwnUse" class="m-1" />
            </div>
            <div>
              <LabelField :label="$t('VesselNomination.parcel.masterForReceivers')" :value="lotProposal.masterForReceivers" class="m-1" />
            </div>
                
        </template>
          <Column  v-if="!readOnly">
            <template #header >
              <ResponsiveButton :label="$t('btn.applyAll')" icon="pi pi-check" class="p-button-text" @click="applySaveDocumentAll"/>
            </template>
            <template #body="element">
                <ResponsiveButton :label="$t('btn.apply')" icon="pi pi-check" class="p-button-text" @click="applySaveDocument(element.data)"/>
            </template>
          </Column>
          <Column expander style="width: 5rem" v-if="!readOnly" />
          <Column :header="'Già inserito'">
            <template #body="element">
              {{  checkDocument(element.data) ? $t('yes') : $t('no') }}
              <!-- {{ element.data.toSend }} -->
            </template>
          </Column>
          <Column field="name" :header="$t('documentType.fk')" dataType="string" :sortable="true">
            <template #body="element">
              {{ element.data.name }}
              <generic-custom-master-data-autocomplete-v-2  v-if="!readOnly"
                v-model="element.data.toSend.idRegistryDocument"
                name="document-type"
                api="masterdata/document-type-combo?getOnlyValid=true"
                :format="{ label: 'description', value: 'id' }" sortField="Description"
                :class="{'p-inputtext-sm mt-1 ': true}" />
            </template>
            
          </Column>
          <Column field="originals" :header="$t('movementInstructions.numberOfOriginals')">
            <template #body="element">
              {{ element.data.originals }}
            </template>
          </Column>
          <Column field="copies" :header="$t('movementInstructions.numberOfCopies')" >
            <template #body="element">
              {{ element.data.copies }}
            </template>
          </Column>
          <Column field="counterSignedBySurveyor" :header="$t('movementInstructions.isCounterSignedByInspector')">
            <template #body="element">
              {{ element.data.counterSignedBySurveyor ? $t('yes') : $t('no') }}
            </template>
          </Column>
          <Column field="counterSignedOrIssueByOther" :header="$t('movementInstructions.isCounterSignedByThirdparty')">
            <template #body="element">
              {{ element.data.counterSignedOrIssueByOther ? $t('yes') : $t('no') }}
            </template>
            </Column>
            <Column field="notes" :header="$t('note')">
            <template #body="element">
              {{ element.data.notes }}
              <InputText type="string" v-model="element.data.toSend.notes" v-if="!readOnly" class="w-full" />
            </template>
          </Column>
          <template #expansion="slotProps"  v-if="!readOnly">
            <DataTable :value="slotProps.data.toSend.receivers" :dataKey="(i) => slotProps.data.toSend.idRegistryDocument + '.'+ i.idRegistryDocumentReceiver"> 
                <Column field="registryDocumentReceiver" :header="$t('movementInstructions.documentReceivers')" sortable></Column>
                <Column field="originals" :header="$t('movementInstructions.numberOfOriginals')" sortable>
                  <template #body="element">
                    <InputText
                        type="number" 
                        @wheel.prevent
                        v-model="element.data.originals"
                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                  </template>
                </Column>
                <Column field="copies" :header="$t('movementInstructions.numberOfCopies')" sortable>
                  <template #body="element">
                    <InputText
                        type="number" 
                        @wheel.prevent
                        v-model="element.data.copies"
                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                  </template>
                </Column>
            </DataTable>
          </template>
      </DataTable>
    </OverlayPanel>
    <div class="grid">

      <div class="col-12">
        <div class="card">

          <div class="grid">
            <Card class="col-12" >
              <template #content>
                <router-link :to="'/discharge-tracking-detail/'+dischargeTrackingRecordId" v-if="dischargeTrackingRecordId != null">{{$t('DischargeTrackingReport.page_title')}}</router-link>
                <Dialog v-model:visible="documentDialogVisible" modal class="p-fluid">
                   <div class="field">
                      <label :class="{'p-error':v$.documentItem.idRegistryDocumentType.$invalid && submittedItem}">{{$t('documentType.fk')}}</label>
                      <generic-custom-master-data-autocomplete-v-2
                        v-model="documentItem.idRegistryDocumentType"
                        name="document-type"
                        :disabled="readOnly"
                        api="masterdata/document-type-combo?getOnlyValid=true"
                        :format="{ label: 'description', value: 'id' }" sortField="Description"
                        :class="{'p-invalid':v$.documentItem.idRegistryDocumentType.$invalid && submittedItem, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.documentItem.idRegistryDocumentType.$invalid && submittedItem) || v$.documentItem.idRegistryDocumentType.$pending.$response">
                          <small class="p-error" v-for="error in v$.documentItem.idRegistryDocumentType.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                   <div class="field">
                    <label for="isCounterSignedByInspector">{{$t('movementInstructions.isCounterSignedByInspector')}}</label>
                    <GenericBooleanDropdown
                      id="isCounterSignedByInspector" 
                      v-model="documentItem.isCounterSignedByInspector" 
                      :disabled="readOnly"
                      class="w-full p-inputtext-sm mt-1 "
                    />
                  </div>
                   <div class="field">
                    <label for="isCounterSignedByThirdparty">{{$t('movementInstructions.isCounterSignedByThirdparty')}}</label>
                    <GenericBooleanDropdown
                      id="isCounterSignedByThirdparty" 
                      v-model="documentItem.isCounterSignedByThirdparty" 
                      :disabled="readOnly"
                      class="w-full p-inputtext-sm mt-1 "
                    />
                  </div>
                  
                   <div class="field">
                    <label for="isIssuedByThirdparty">{{$t('movementInstructions.isIssuedByThirdparty')}}</label>
                    <GenericBooleanDropdown
                      id="isIssuedByThirdparty" 
                      v-model="documentItem.isIssuedByThirdparty" 
                      :disabled="readOnly"
                      class="w-full p-inputtext-sm mt-1 "
                    />
                  </div>
                   <div class="field">
                      <label :class="{'p-error':v$.documentItem.note.$invalid && submittedItem}">{{$t('note')}}</label>
                      <Textarea 
                        :disabled="readOnly"
                        v-model="documentItem.note" :autoResize="true" rows="5" cols="30"
                        :class="{'p-invalid':v$.documentItem.note.$invalid && submittedItem, 'w-full p-inputtext-sm mt-1 ': true}" />
                  </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="documentDialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveDocument" :disabled="documentItemDisabled" />
                    </template>
                </Dialog>
                <div class="grid mt-4">
                  <div class="col-12">
                    <DataTable :reorderableColumns="true" :value="items" showGridlines stripedRows dataKey="id"
                      v-model:selection="selectedItems" selectionMode="single" @rowSelect="onItemSelect">
                        <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('movementInstructions.documents')}}</div>
                                <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event)" class="p-button-warning mt-1" v-if="proposal && lotProposal && lotProposal.documents"/>
                              </template>

                            <template #end>
                               <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openDocumentDialog"  />

                            </template>
                        </Toolbar>
                       </template>
                       
                        <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                          <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openDocumentDialogEdit(slotProps.data)" />
                            <ResponsiveButton icon="pi pi-trash" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteDocument(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="registryDocumentType" :header="$t('documentType.fk')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.registryDocumentType}}
                            </template>
                          <template #editor="{ data }">
                            <GenericCustomMasterDataSelect 
                              name="document-type"
                              v-model="data.idRegistryDocumentType" 
                              api="masterdata/document-type-combo?getOnlyValid=true"
                              :format="{ label: 'description', value: 'id' }" sortField="Description" />
                          </template>
                        </Column>
                        <Column field="isCounterSignedByInspector" :header="$t('movementInstructions.isCounterSignedByInspector')" dataType="boolean" :sortable="true">
                            <template #body="element">
                              <i class="pi" :class="{'true-icon pi-check-circle': element.data.isCounterSignedByInspector, 'false-icon pi-times-circle': !element.data.isCounterSignedByInspector}"></i>
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        <Column field="isCounterSignedByThirdparty" :header="$t('movementInstructions.isCounterSignedByThirdparty')" dataType="boolean" :sortable="true">
                            <template #body="element">
                              <i class="pi" :class="{'true-icon pi-check-circle': element.data.isCounterSignedByThirdparty, 'false-icon pi-times-circle': !element.data.isCounterSignedByThirdparty}"></i>
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        <Column field="isIssuedByThirdparty" :header="$t('movementInstructions.isIssuedByThirdparty')" dataType="boolean" :sortable="true">
                            <template #body="element">
                              <i class="pi" :class="{'true-icon pi-check-circle': element.data.isIssuedByThirdparty, 'false-icon pi-times-circle': !element.data.isIssuedByThirdparty}"></i>
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        <Column field="note" :header="$t('note')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.note}}
                            </template>
                          <template #editor="{ data, field }">
                            <InputText type="string" v-model="data[field]" />
                          </template>
                        </Column>
                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
            <Card class="col-12" >
              <template #content>                  
                <Dialog v-model:visible="documentReceiverDialogVisible" modal class="p-fluid">
                    <div class="field">
                      <label :class="{'p-error':v$.documentReceiverItem.idRegistryDocumentReceiver.$invalid && submittedReceiver}">{{$t('documentReceiver.fk')}}</label>
                      <generic-custom-master-data-autocomplete-v-2
                        v-model="documentReceiverItem.idRegistryDocumentReceiver"
                        name="document-receivers"
                        :disabled="readOnly"
                        :class="{'p-invalid':v$.documentReceiverItem.idRegistryDocumentReceiver.$invalid && submittedReceiver, 'w-full p-inputtext-sm mt-1 ': true}"
                        api="masterdata/document-receiver-combo?getOnlyValid=true" />
                        <div v-if="(v$.documentReceiverItem.idRegistryDocumentReceiver.$invalid && submittedReceiver) || v$.documentReceiverItem.idRegistryDocumentReceiver.$pending.$response">
                          <small class="p-error" v-for="error in v$.documentReceiverItem.idRegistryDocumentReceiver.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                    <div class="field">
                      <label :class="{'p-error':v$.documentReceiverItem.numberOfOriginals.$invalid && submittedReceiver}">{{$t('movementInstructions.numberOfOriginals')}}</label>
                      <InputText
                        type="number" 
                        :disabled="readOnly"
                        @wheel.prevent
                        v-model="documentReceiverItem.numberOfOriginals"
                        :class="{'p-invalid':v$.documentReceiverItem.numberOfOriginals.$invalid && submittedReceiver, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.documentReceiverItem.numberOfOriginals.$invalid && submittedReceiver) || v$.documentReceiverItem.numberOfOriginals.$pending.$response">
                          <small class="p-error" v-for="error in v$.documentReceiverItem.numberOfOriginals.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                    <div class="field">
                      <label :class="{'p-error':v$.documentReceiverItem.numberOfCopies.$invalid && submittedReceiver}">{{$t('movementInstructions.numberOfCopies')}}</label>
                      <InputText
                        type="number" 
                        @wheel.prevent
                        :disabled="readOnly"
                        v-model="documentReceiverItem.numberOfCopies"
                        :class="{'p-invalid':v$.documentReceiverItem.numberOfCopies.$invalid && submittedReceiver, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.documentReceiverItem.numberOfCopies.$invalid && submittedReceiver) || v$.documentReceiverItem.numberOfCopies.$pending.$response">
                          <small class="p-error" v-for="error in v$.documentReceiverItem.numberOfCopies.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                  </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="documentReceiverDialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveDocumentReceiver" :disabled="documentReceiverDisabled"/>
                    </template>
                </Dialog>
                <div class="grid mt-4">
                  <div class="col-12">
                    <DataTable :value="receiversItems" showGridlines stripedRows :reorderableColumns="true"
                      dataKey="id">
                         <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('movementInstructions.documentReceivers')}}</div>
                            </template>

                            <template #end>
                               <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openDocumentReceiverDialog"  />
                            </template>
                        </Toolbar>
                       </template>
                        <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                          <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openDocumentReceiverDialogEdit(slotProps.data)" />
                            <ResponsiveButton icon="pi pi-trash" :disabled="!uiPermissions('MovementInstruction.Lot.Documents').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteDocumentReceiver(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="registryDocumentReceiver" :header="$t('documentReceiver.fk')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.registryDocumentReceiver}}
                            </template>
                          <template #editor="{ data }">
                            <GenericCustomMasterDataSelect 
                              name="document-receivers"
                              v-model="data.idRegistryDocumentReceiver" 
                              api="masterdata/document-receiver-combo?getOnlyValid=true" />
                          </template>
                        </Column>
                        <Column field="numberOfOriginals" :header="$t('movementInstructions.numberOfOriginals')" dataType="number" :sortable="true">
                            <template #body="element">
                              {{element.data.numberOfOriginals}}
                            </template>
                            <template #editor="{ data, field }">
                             <InputText type="number" v-model="data[field]" autofocus />
                            </template>
                        </Column>
                        <Column field="numberOfCopies" :header="$t('movementInstructions.numberOfCopies')" dataType="number" :sortable="true">
                            <template #body="element">
                              {{element.data.numberOfCopies}}
                            </template>
                            <template #editor="{ data, field }">
                             <InputText type="number" v-model="data[field]" autofocus />
                            </template>
                        </Column>
                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
